import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import Layout from '../layout/Layout';
import {
  checkUserIsAuth, removeUserFromStorage, getUserRole, getUserPermissions,
} from '../utils/users';

const AuthRoute = ({ children, ...rest }): JSX.Element => {
  const locationObject = useLocation();
  const userPermissions = getUserPermissions() || [];

  const checkRole = (): JSX.Element | null => {
    if (getUserRole() === null) {
      // Clean storage token
      removeUserFromStorage();
      return <Navigate to="/login" />;
    }

    return null;
  };

  const checkRoleVisibility = (): JSX.Element | null => {
    // if user has no permission
    if (
      rest['visibility'] !== undefined
        && rest['visibility'].indexOf(getUserRole()) === -1
    ) {
      return <Navigate to="/" />;
    }

    return null;
  };

  const checkSpecificPermission = (): JSX.Element | null => {
    if ('checkPermissionExpressionMethod' in rest && rest['checkPermissionExpressionMethod'] != null) {
      if (!rest['checkPermissionExpressionMethod']()) {
        if (locationObject.pathname === '/') {
          removeUserFromStorage();
          return <Navigate to="/login" />;
        }
        return <Navigate to="/" />;
      }
    }

    if ('hasEveryPermission' in rest && rest['hasEveryPermission'] != null) {
      if (
        !(rest['hasEveryPermission'] || [])
          .every((element) => userPermissions.includes(element))
      ) {
        if (locationObject.pathname === '/') {
          removeUserFromStorage();
          return <Navigate to="/login" />;
        }
        return <Navigate to="/" />;
      }
    }

    if ('permissions' in rest && rest['permissions'] != null) {
      if (
        !(rest['permissions'] || [])
          .some((element) => userPermissions.includes(element))
      ) {
        if (locationObject.pathname === '/') {
          removeUserFromStorage();
          return <Navigate to="/login" />;
        }
        return <Navigate to="/" />;
      }
    }

    return null;
  };

  return (
    <>
      {checkRole()}
      {checkRoleVisibility()}
      {checkSpecificPermission()}
      {
        checkUserIsAuth()
          ? (
            <Layout>
              {children}
            </Layout>
          )
          : (
            <Navigate
              to="/login"
            />
          )
      }
    </>
  );
};

AuthRoute.propTypes = {
  children: PropTypes.shape({}).isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string),
  hasEveryPermission: PropTypes.arrayOf(PropTypes.string),
  checkPermissionExpressionMethod: PropTypes.func,
};

AuthRoute.defaultProps = {
  hasEveryPermission: undefined,
  permissions: undefined,
  checkPermissionExpressionMethod: undefined,
};

export default AuthRoute;
